// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

export default {
  2: state => {
    const newState = produce(state, draft => {
      draft.orderId = null;
      if (state.form && state.orderId) {
        draft.form.orderId = state.orderId;
        delete draft.orderId;
      }
    });

    return newState;
  },
};
